export default {"src":"/_next/static/media/text-instruction-three.5eebf5ba.svg","height":75,"width":75,"blurWidth":0,"blurHeight":0};